import * as React from "react";
import {ConfigContext} from "../../context/ConfigContext";
import {Tab} from "semantic-ui-react";
import {PageWithSidebar} from "../../../style/page_with_sidebar";
import {SchedulerTasksPage} from "./SchedulerTasksPage";
import {SchedulerReportConfigs} from "./SchedulerReportConfigs";
import {clampTabIndex} from "../../context/TabSession";


export function SchedulerTabView(props: any) {

    const context = React.useContext(ConfigContext)
    const panes = [
        { pos: 1, menuItem: 'Jobs', render: () => <Tab.Pane><SchedulerTasksPage /></Tab.Pane> },
        { pos: 2, menuItem: 'Reports', render: () => <Tab.Pane><SchedulerReportConfigs /></Tab.Pane> },

    ]

    return <PageWithSidebar activeMenu="Scheduler">
        <Tab
            id={"SchedulerTabView"}
            className={"flexTab"}
            {...props = props}
            panes={panes}
            defaultActiveIndex={clampTabIndex(context.tabSession.schedulerTab, panes)}
            onTabChange={(_, data) => {
                context.setSingleTabSession("schedulerTab", parseInt(data.activeIndex.toString()), null, null)
            }}
            key={panes.length}
        />
    </PageWithSidebar>
}
